module.exports = __webpack_public_path__ + "static/media/OSTR01.2da12eb6.jpg";